exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "a.small{color:#b9b9b9;font-weight:600;font-size:100%}", ""]);

// exports
